module.exports = __webpack_public_path__ + "static/img/dlfsd.90f9b212.png";